import { DeclareMethod } from '/imports/methods';

interface EnergyExportArg {
  startDate: string;
  endDate: string;
  consumptionMeterIds: string[];
  productionMeterIds: string[];
  resolution: string;
}

export const createEnergyExport = DeclareMethod<EnergyExportArg, string>('createEnergyExport');
